import React from "react";

const Error = () => {
  return (
    <>
      <p>Oops something went wrong!</p>
    </>
  );
};

export default Error;
